import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import AvailableTranslationCacheName from "../../utils/AvailableTranslationCacheName";
import { sendTranslationToReview } from "../../api/sendTranslationToReview";

export function useSendTranslationToReview(onSuccessCallback?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendTranslationToReview,
    onSuccess: () => {
      toast.success("Translation successfully sent to review phase");
      queryClient.invalidateQueries(AvailableTranslationCacheName.getAvailableTranslation());

      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: (error: AxiosError) => {
      const errorMessage = ErrorUtils.getErrorMessage(error);
      toast.error(errorMessage, {
        autoClose: false,
      });
    },
  });
}
